import React from 'react';
import { SizeAttributeLabel } from './SizeAttributeLabel';
import { useTranslation } from 'react-i18next';
import { SizeChoice } from '@gift/attributes-size-core/SizeAttributeOptions';
import styles from './SizeAttributeDropdownItem.module.scss';

export const SizeAttributeDropdownItem = ({ hasPreview, ...choice }: Props) => {

    const { t } = useTranslation();

    if (!hasPreview) {
        return <SizeAttributeLabel {...choice} />;
    }

    return (
        <>
            {choice.options?.assetUrl ? (
                <img
                    className={styles.preview}
                    src={choice.options.assetUrl}
                    alt={t(choice.label)} />
            ) : (
                <div className={styles.preview} />
            )}
            <SizeAttributeLabel {...choice} />
        </>
    );
};

type Props = SizeChoice & {
    hasPreview: boolean;
};
